import { Avatar, Space } from 'antd'
import { useMemo } from 'react';
import ChinaFlag from '../../../../components/icons/flags/ChinaFlag';
import HongKongFlag from '../../../../components/icons/flags/HongKongFlag';
import IndiaFlag from '../../../../components/icons/flags/IndiaFlag';
import IndonesiaFlag from '../../../../components/icons/flags/IndonesiaFlag';
import JapanFlag from '../../../../components/icons/flags/JapanFlag';
import MalasiaFlag from '../../../../components/icons/flags/MalasiaFlag';
import PhlippinesFlag from '../../../../components/icons/flags/PhlippinesFlag';
import SingaporeFlag from '../../../../components/icons/flags/SingaporeFlag';
import SKoreaFlag from '../../../../components/icons/flags/SKoreaFlag';
import TaiwanFlag from '../../../../components/icons/flags/TaiwanFlag';
import ThailandFlag from '../../../../components/icons/flags/ThailandFlag';
import VietnamFlag from '../../../../components/icons/flags/VietnamFlag';
import AustraliaFlag from '../../../../components/icons/flags/AustraliaFlag';
import { getColorByLetter } from '../../../../common/helpers';


interface Props {
    data: any
}
const DiscoverBrandItemCell = (props: Props) => {
    const { data } = props;

    const flagIcon = useMemo(() => {
        switch (data?.location) {
            case "China":
                return <ChinaFlag />
            case "Hong Kong":
                return <HongKongFlag />
            case "India":
                return <IndiaFlag />
            case "Indonesia":
                return <IndonesiaFlag />
            case "Japan":
                return <JapanFlag />
            case "Malaysia":
                return <MalasiaFlag />
            case "Philippines":
                return <PhlippinesFlag />
            case "Singapore":
                return <SingaporeFlag />
            case "South Korea":
                return <SKoreaFlag />
            case "Taiwan":
                return <TaiwanFlag />
            case "Thailand":
                return <ThailandFlag />
            case "Vietnam":
                return <VietnamFlag />
            case "Australia":
                return <AustraliaFlag />
            case "Thailand":
                return <ThailandFlag />

            default:
                return <></>
        }
    }, [data])

    return (
        <div className='flex items-center gap-x-[12px]'>
            <Avatar shape="square" size={'large'} style={getColorByLetter(data?.brand_name?.charAt(0))}>{data?.brand_name?.charAt(0)}</Avatar>
            <div>
                <p className='mb-[6px] text-[13px] font-[500]'>{data?.brand_name}</p>
                <div className='flex items-center gap-x-[6px]'>
                    {flagIcon}
                    <p className='text-[12px] text-[#475467] m-0'>{data?.location}</p>
                </div>
            </div>
        </div>
    )
}

export default DiscoverBrandItemCell